import { render } from "./HistoryViewDialog.vue?vue&type=template&id=3c13d490&ts=true"
import script from "./HistoryViewDialog.vue?vue&type=script&lang=ts"
export * from "./HistoryViewDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__